// FIX: NetworkTileBtcToSilver not MarketTileExchangeFlowIn
import { SingleDataValue } from '.';
import { ThemedFlex } from '../../theme/ThemedFlex';

export const MarketTileExchangeFlowIn = ({ data, formatNumber, animate }) => {
  const numberValue = data?.s06?.bitcoin?.market_data?.current_price?.xag != null 
    ? `${formatNumber(data.s06.bitcoin.market_data.current_price.xag, 0)} oz.`
    : '';

  return (
    <ThemedFlex
      direction="column"
      mb="12px"
      py="18px"
      px="20px"
      flex={1}
      borderRadius={3}
      className={animate ? 'gray-border-custom gray-border' : ''}
    >
      <SingleDataValue label="Silver~BTC" value={numberValue} />
    </ThemedFlex>
  );
};